module.exports = __webpack_public_path__ + "static/media/behance-logo.b8ade4ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/behance-logo.jpg
// module id = 136
// module chunks = 0